module.exports = __webpack_public_path__ + "img/Adam_Friedman.970227ad.jpg";